export enum IncidentsTabs {
    OPEN = 'open',
    CLOSED = 'resolved',
}
